<template>
  <card card-body-classes="table-full-width">
    <edit-fare-dialog :show="showEdit" :form-details="editFare" @close="showEdit=false" :discounts="discounts" :municipalities="municipalities"/>
    <h4 slot="header" class="card-title">{{ $t('fares.table.title') }}</h4>
    <div>
      <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
            class="select-primary mb-3 pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
        >
          <el-option
              class="select-primary"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="row">
            <div class="col-6">
              <base-input>
                <el-input
                    type="search"
                    class="mb-3 search-input"
                    prefix-icon="el-icon-search"
                    :placeholder="$t('generic.searchInTablePlaceholder')"
                    v-model="searchQuery"
                    aria-controls="datatables"/>
              </base-input>
            </div>
            <div class="col-6" v-if="$auth.can({fare: 'create'}, 'permissions')">
              <create-fare-btn :fare-group-id="fareGroupId" :discounts="discounts" :municipalities="municipalities"/>
            </div>
          </div>
        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
        <el-table-column type="expand">
          <template slot-scope="props">
            <fare-details :details="props.row"/>
          </template>
        </el-table-column>
        <el-table-column :label="$t('generic.discountID')" min-width="180">
          <div slot-scope="{ row }">
            {{ row.discount_id }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('fares.details.starts_at')" min-width="120">
          <div slot-scope="{ row }">
            <!-- TODO: translate time -->
            {{ row.starts_at | dateOnly }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('fares.details.ends_at')" min-width="120">
          <div v-if="row.ends_at" slot-scope="{ row }">
            <!-- TODO: translate time -->
            {{ row.ends_at | dateOnly }}
          </div>
          <div v-else slot-scope="{ row }">
            -
          </div>
        </el-table-column>
        <el-table-column :label="$t('generic.description')" min-width="180">
          <div slot-scope="{ row }">
            {{ row.description }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('fares.details.price')" min-width="180">
          <div slot-scope="{ row }">
            {{ row.pricing.single.price ? row.pricing.single.price : 0 | price }}
          </div>
        </el-table-column>
        <el-table-column :label="$t('fares.details.month_price')" min-width="180">
          <div slot-scope="{ row }" v-if="row.pricing.caps">
            {{ row.pricing.caps.calendar_month.price | price }}
          </div>
          <div slot-scope="{ row }" v-else>
            -
          </div>
        </el-table-column>
        <!-- Updated & Created -->
        <el-table-column :label="$t('fares.details.municipality_id')" min-width="180">
          <div slot-scope="{ row }">
            <!-- TODO: translate time -->
            {{ row.municipality_id }}
          </div>
        </el-table-column>
        <!--        <el-table-column :label="$t('generic.created')" min-width="180">-->
        <!--          <div slot-scope="{ row }">-->
        <!--            &lt;!&ndash; TODO: translate time &ndash;&gt;-->
        <!--            {{ row.created_at | time }}-->
        <!--          </div>-->
        <!--        </el-table-column>-->
        <el-table-column :min-width="135" align="right"
                         v-if="editable && ($auth.can({fare: 'update'}, 'permissions') || $auth.can({fare: 'delete'}, 'permissions'))">
          <div slot-scope="props">
            <base-button
                v-if="$auth.can({fare: 'update'}, 'permissions')"
                @click.native="handleEdit(props.$index, props.row)"
                class="mr-2"
                type="info"
                size="sm"
                icon
                round
                simple>
              <i class="tim-icons icon-pencil"></i>
            </base-button>
            <base-button
                v-if="$auth.can({fare: 'delete'}, 'permissions')"
                @click.native="handleDelete(props.$index, props.row)"
                class=""
                type="danger"
                size="sm"
                icon
                round
                simple>
              <i class="tim-icons icon-simple-remove"></i>
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
import swal from 'sweetalert2';
import {BaseAlert, BasePagination} from "../../components";
import {Option, Select, Table, TableColumn} from "element-ui";
import Fuse from "fuse.js";
import CreateFareBtn from "./CreateFareBtn";
import EditFareDialog from "./EditFareDialog";
import {mapActions, mapState} from "vuex";
import FareDetails from "./FareDetails";

export default {
  name: 'fares-table',
  components: {
    FareDetails,
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    CreateFareBtn,
    EditFareDialog
  },
  props: {
    fareGroupId: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      }
    },
  },
  computed: {
    ...mapState({
      loading: state => state.fare_group_fares.loading,
      error: state => state.fare_group_fares.error,
      discounts: state => state.discount.data,
      municipalities: state => state.municipalities.data,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['discount_id', 'starts_at'],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      showEdit: false,
      editFare: {},
    };
  },
  methods: {
    ...mapActions(['DeleteFare', 'LoadFareGroupFares', 'LoadDiscounts', 'LoadMunicipalities']),
    handleEdit(index, row) {
      this.editFare = {
        id: row.id,
        discount_id: row.discount_id,
        municipality_id: row.municipality_id,
        fare_group_id: this.fareGroupId,
        month_cap: row.pricing.caps != null && row.pricing.caps.calendar_month != null && row.pricing.caps.calendar_month.price > 0 ? true : false,
        month_price: row.pricing.caps ? (row.pricing.caps.calendar_month.price / 100).toFixed(2) : 0,
        price: (row.pricing.single.price / 100).toFixed(2),
        starts_at: row.starts_at,
        ends_at_provided: row.ends_at != null,
        ends_at: row.ends_at,
        description: row.description
      };
      this.showEdit = true;
    },
    handleDelete(index, row) {
      swal({
        text: `'${row.discount_id}' - ${this.$options.filters.dateOnly(row.starts_at)}`,
        title: this.$t('fares.delete.text'),
        confirmButtonText: this.$t('fares.delete.actionBtnLabel'),
        cancelButtonText: this.$t('fares.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteFare(row).then(() => {
            if (this.error == null) {
              // this.deleteRow(row);
              this.$notify({
                type: 'success',
                message: this.$t('fares.delete.deletedNotification', {
                  discount_id: row.discount_id,
                  starts_at: this.$options.filters.dateOnly(row.starts_at)
                }),
                icon: 'tim-icons icon-alert-circle-exc'
              })
            }

          })
        }
      });
    },
  },
  mounted() {
    this.LoadFareGroupFares(this.fareGroupId)
    this.LoadDiscounts()
    this.LoadMunicipalities({resident_pricing:true})
  },
  watch: {
    "$store.state.fare_group_fares.data"(data) {
      this.tableData = data
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  }
};
</script>
<style></style>
